import React, { useMemo, useState } from 'react';
import { Download, Smartphone } from 'lucide-react';
import s3Api from '../services/s3Api';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

const AppDownload = () => {
  const { user } = useAuth();
  const { success, error } = useToast();
  const [isDownloading, setIsDownloading] = useState(false);

  const cemeteryId = useMemo(
    () => user?.cemetery_id ?? user?.cemeteryId ?? null,
    [user]
  );

  const apkKey = useMemo(() => {
    if (!cemeteryId) return '';
    return `cemetery/${cemeteryId}/kiosk_app/app-debug.apk`;
  }, [cemeteryId]);

  const handleDownload = async () => {
    if (!apkKey) {
      error('묘지 정보를 확인할 수 없습니다.');
      return;
    }

    setIsDownloading(true);
    try {
      const res = await s3Api.generateDownloadUrl(apkKey);
      const downloadUrl = res?.downloadUrl;

      if (!downloadUrl) {
        throw new Error('다운로드 URL을 받지 못했습니다.');
      }

      window.open(downloadUrl, '_blank', 'noopener,noreferrer');
      success('앱 다운로드를 시작합니다.');
    } catch (e) {
      error(e.message || '앱 다운로드 URL 생성에 실패했습니다.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">App 다운로드</h1>
      </div>

      <div className="card max-w-2xl">
        <div className="flex items-start gap-4 mb-6">
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: '#eef2ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Smartphone size={22} color="#4f46e5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">키오스크 앱 APK 다운로드</h2>
            <p className="text-sm text-gray-600">
              현재 로그인한 묘지의 S3 경로에서 APK 파일을 받아옵니다.
            </p>
          </div>
        </div>

        <div className="mb-4 text-sm text-gray-700">
          <div className="mb-1">
            <span className="font-medium">묘지 ID:</span> {cemeteryId ?? '-'}
          </div>
          <div style={{ wordBreak: 'break-all' }}>
            <span className="font-medium">S3 경로:</span> {apkKey || '-'}
          </div>
        </div>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleDownload}
          disabled={isDownloading || !apkKey}
        >
          <Download size={16} />
          {isDownloading ? '다운로드 준비 중...' : 'APK 다운로드'}
        </button>
      </div>
    </div>
  );
};

export default AppDownload;
